import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LocalActions } from '@local/client-contracts';
import { InvokeCommand } from '../../models/invoke-command.model';

@Component({
  selector: 'local-actions-item',
  templateUrl: './local-actions-item.component.html',
  styleUrls: ['./local-actions-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocalActionsItemComponent {
  @Input() model: LocalActions.LocalActionItem;
  @Input() set selected(value: boolean) {
    this._selected = value;
  }
  @Input() index: number;
  @Input() isLauncher: boolean;
  @Input() isOneLine: boolean;
  @Input() isClickable: boolean = true;
  @Output() invoke = new EventEmitter<InvokeCommand>();

  get selected() {
    return this._selected;
  }
  private _selected: boolean;

  constructor() {}

  async onInvoke(invokeData: InvokeCommand): Promise<void> {
    this.invoke.emit({ ...invokeData, invokerItem: this.model });
  }
}
